export const GRID_NAMES = {
  JOB_ROLES_SELECTION: "JOB_ROLES_SELECTION",
  SKILL_SELECTION: "SKILL_SELECTION",
  JOB_OF_INTEREST_SELECTION: "JOB_OF_INTEREST_SELECTION",
  SKILL_GOALS_SELECTION: "SKILL_GOALS_SELECTION",
  DASHBOARD_MY_SKILLS: "DASHBOARD_MY_SKILLS",
  DASHBOARD_JOBS_OF_INTEREST: "DASHBOARD_JOB_OF_INTEREST",
};
